export const FINAL_ASSIGNMENT_CONFIRMATION_KEY = 'message.error.final_employee_assignment_confirmation_required';

export const finalAssignmentConfirmationDetails = (error) => {
  const response = error?.response;
  const data = response?.data || {};

  if (response?.status !== 409 || data?.translation_key !== FINAL_ASSIGNMENT_CONFIRMATION_KEY) {
    return null;
  }

  const employeeHashIds = Array.isArray(data?.data?.employee_hash_ids)
    ? data.data.employee_hash_ids
    : [];

  return {
    employeeHashIds,
    count: Number(data?.data?.employee_count) || employeeHashIds.length || null,
  };
};

export const withFinalAssignmentConfirmation = (payload = {}) => ({
  ...payload,
  confirm_final_assignment: true,
});
